import type { MappedLocation } from 'shared';

import { extractAnalyticsDataLib } from '../analytics-data-extraction';
import { sendEvent } from './lib';
import { transformFilterParams } from './utils';
import type {
  DetailsPageOpenParams,
  SelectFareFamilyParams,
} from '../analytics';

/**
 * flights_offer_detail_viewed - Просмотр деталей оффера/карточки
 */
export const offerDetailViewed = (
  params: DetailsPageOpenParams,
  locations: MappedLocation[],
) => {
  const { offer } = params;
  const parsed = extractAnalyticsDataLib.offer(offer);

  const depLocation = locations[locations.length - 1];
  const arrLocation = locations[0];
  const lastFlight = offer.flights[offer.flights.length - 1];

  sendEvent('flights_offer_detail_viewed', {
    airlines: parsed.airlines.map(a => a.iata),
    price: parsed.price,
    is_refundable: parsed.isRefundable,
    is_exchangeable: parsed.isExchangeable,
    baggage: parsed.baggage,
    city_to: arrLocation?.city?.name || arrLocation?.name,
    city_from: depLocation?.city?.name || depLocation?.name,
    date_from: offer.flights[0].segments[0].dep?.at?.split('T')[0],
    date_to: lastFlight?.segments[0]?.dep?.at?.split('T')[0],
    count_connections: parsed.countConnections,
    count_stops: parsed.countStops,
    is_direct: parsed.isDirect,
    offer_position: params.index + 1,
    airport_from: parsed.departure.airport,
    airport_to: parsed.lastArrival?.airport,
    has_filter: params.hasFilter,
    filter_params: transformFilterParams(params.filterParams),
    is_charter: parsed.isCharter,
  });
};

/**
 * flights_tariff_button_clicked - Клик "Перейти к тарифам"
 */
export const tariffButtonClicked = () => {
  sendEvent('flights_tariff_button_clicked');
};

/**
 * flights_passenger_page_opened - Перешел на страницу "Данные пассажиров"
 */
export const passengerPageOpened = (params: SelectFareFamilyParams) => {
  const fareFamilyName = params.fareFamilyName || params.choice.code || '';

  const options = params.descriptions
    ? params.descriptions.map(d => d.name)
    : [];

  sendEvent('flights_passenger_page_opened', {
    has_fare_family_base: !!params.isBaseFare,
    // если выбран базовый тариф, то надо заменить его на 1
    fare_family_index: params.isBaseFare ? 1 : params.choice.id,
    fare_family_name: fareFamilyName,
    options,
  });
};
